'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const callbackMap = new Map();
const getSize = () => {
  if (typeof window !== 'object') {
    return {
      width: undefined,
      height: undefined
    };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};
const handleResize = () => {
  const size = getSize();
  callbackMap.forEach(callback => callback(size));
};
var useWindowSize = ({
  fixedSize = false
}) => {
  const [windowSize, setWindowSize] = React.useState(getSize);
  const {
    current: id
  } = React.useRef({});

  // Effects only run on the client
  React.useEffect(() => {
    // Add the listener if this is the first one
    if (callbackMap.size === 0 && !fixedSize) {
      window.addEventListener('resize', handleResize);
    }
    callbackMap.set(id, () => setWindowSize(getSize()));
    return () => {
      callbackMap.delete(id);

      // Remove the listener if this is the last one
      if (callbackMap.size === 0) {
        window.removeEventListener('resize', handleResize);
      }
    };
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return windowSize;
};

exports["default"] = useWindowSize;
